// extracted by mini-css-extract-plugin
module.exports = {"onceCanvasBox":"onceCanvasBox--3DKPK","oncePage":"oncePage--1mpdP","backgroundImg":"backgroundImg--1usUb","canvasLayer":"canvasLayer--1A5yE"};